import { ActionContext } from 'vuex';
import { HttpStore } from '@integrai/ui';
import StateType from './state.type';

export default {
  async getProducts(context: ActionContext<StateType, {}>, filters: any): Promise<void> {
    const { commit } = context || {};

    commit('toggleLoading', true);

    try {
      const response: any = await HttpStore.post('products/filter', filters);

      commit('setProducts', response.products);
      commit('setTotal', response.total);
      commit('setTotalStock', response.totalStock);
      commit('toggleLoading', false);
    } catch {
      commit('toggleLoading', false);
    }
  },
  async exportAllProducts(context: ActionContext<StateType, {}>, filters: any): Promise<any> {
    const { commit } = context || {};

    commit('toggleLoading', true);

    try {
      const response = await HttpStore.request({
        url: 'products/export',
        method: 'POST',
        data: filters,
        responseType: 'blob',
      });

      commit('toggleLoading', false);
      return response;
    } catch {
      commit('toggleLoading', false);
    }
    return null;
  },
};
